<template>
  <div>

    <nav class="w3-sidebar w3-bar-block w3-collapse w3-animate-left w3-card" style="z-index:3;width:250px;" id="mySidebar">
      <a class="w3-bar-item w3-button w3-border-bottom w3-large" href="#" style="background-color: bisque;">
        <img src="/images/w3schools.png" style="width: 100%; height: 100%;" />
      </a>
      <a class="w3-bar-item w3-button w3-hide-large w3-large" href="javascript:void(0)" @click="w3_close()">
        Close <i class="fa fa-remove"></i>
      </a>

      <!-- 
          <a class="w3-bar-item w3-button w3-teal" href="#">Home</a>
          <a class="w3-bar-item w3-button" href="#">Link 1</a> 
      -->
      <!-- <RouterLink class="w3-bar-item w3-button" v-for="(x,i) in menu" :key="i" :to="getItem2(x.id).path">{{ x.label }}</RouterLink> -->

      <template v-for="(x,i) in menu">
        <template v-if="x.children==undefined">
          <router-link :key="i" :to="getItem2(x.id).path" class="w3-bar-item w3-button" exact
            :class="{ 'w3-yellow': $route.path === `${getItem2(x.id).path}` }">
            {{x.label}}
          </router-link>
        </template>
        <template v-else>
          <div>
            <a class="w3-bar-item w3-button" @click="myAccordion(`demo_${x.id}`)" href="javascript:void(0)">
              {{`${x.label} `}}<i class="fa fa-caret-down"></i></a>
          </div>
          <div :id="`demo_${x.id}`" class="w3-hide">
            <router-link v-for="(y,j) in x.children " :key="j" :to="getItem2(y.id).path" class="w3-bar-item w3-button"
              exact :class="{ 'w3-yellow': $route.path === `${getItem2(y.id).path}` }">
              {{y.label}}
            </router-link>
          </div>
        </template>
      </template>

      <!-- 
      <router-link
        v-for="(x,i) in menu" :key="i"
        :to="getItem2(x.id).path"
        class="w3-bar-item w3-button"
        exact
        :class="{ 'w3-yellow': $route.path === `${getItem2(x.id).path}` }"
      >
        {{x.label}}
      </router-link>
 -->


      <!-- <a class="w3-bar-item w3-button" href="#">Link 2</a>
      <a class="w3-bar-item w3-button" href="#">Link 3</a>
      <a class="w3-bar-item w3-button" href="#">Link 4</a>
      <a class="w3-bar-item w3-button" href="#">Link 5</a> -->
      <!--       
      <div>
        <a class="w3-bar-item w3-button" @click="myAccordion('demo')" href="javascript:void(0)">Dropdown <i
            class="fa fa-caret-down"></i></a>
        <div id="demo" class="w3-hide">
          <a class="w3-bar-item w3-button" href="#">Link</a>
          <a class="w3-bar-item w3-button" href="#">Link</a>
          <a class="w3-bar-item w3-button" href="#">Link</a>
        </div>
      </div>
 -->
      <div>

        <!-- <ul>
          <li v-for="(x, i) in menu" :key="i">
            {{ x.label }} {{ getItem2(x.id).path }}
            <ul v-if="x.children != undefined">
              <li v-for="(y, j) in x.children" :key="j">
                {{ y.label }} {{ getItem2(y.id).path }}
              </li>
            </ul>
          </li>
        </ul> -->

      </div>





    </nav>





    <div class="w3-overlay w3-hide-large w3-animate-opacity" @click="w3_close()" style="cursor:pointer" id="myOverlay">
    </div>

    <div class="w3-main" style="margin-left:250px;">

      <div id="myTop" class="w3-container w3-top w3-theme w3-large">
        <p><i class="fa fa-bars w3-button w3-teal w3-hide-large w3-xlarge" @click="w3_open()"></i>
          <span id="myIntro" class="w3-hide"></span>
        </p>
      </div>

      <header class="w3-container w3-theme" style="padding:64px 32px; position: relative;">
        <a href="/Admin" style="position: absolute; left:20px;bottom: 10px;">Go to work</a>
        <h1 class="w3-xxlarge">Lộc Trời Group</h1>
        <div class="w3-display-middle">Middle</div>


      </header>

      <!-- this is page start -->
      <router-view></router-view>

      <footer class="w3-container w3-theme" style="padding:32px">
        <p>thuc101@gmail.com - {{ getNgay() }}</p>
      </footer>

    </div>

  </div>
</template>
<script>

import fetchClient from '@/fetchClient';
import XuLy from '@/XuLy';
import menuMixin from "@/menuMixin";
import { RouterLink } from 'vue-router';
export default {
  name: '',
  mixins: [menuMixin],
  components: {
  },
  data() {
    return {
      msg: 'Hello world',
      menu: [],
    }
  },
  mounted() {
    this.menu = this.getMenu("/");
    this.loadAllJs().then(() => {
      this.loadAllCss();
    })
    window.onscroll = this.myFunction(); //function () { this.myFunction() };


  },
  methods: {
    getNgay() {
      return new Date()
    },
    async GetWeather() {
      return await fetchClient.get(`/api/First/GetAll1`)
        .then(res => {
          this.msg = res.data.ds;
        })
        .catch(err => {
          XuLy.XuLyErr(err);
        })
    },
    async loadAllCss() {

      return await loadMultipleCss([
        '/W3LeftRight/w3.css',
        '/W3LeftRight/w3-theme-light-blue.css',
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
        //E:\NetCore_6_2025\NetWebToVue4\ClientApp\public\W3LeftRight\w3.css
        // 'https://www.w3schools.com/w3css/5/w3.css',
        // 'https://www.w3schools.com/lib/w3-theme-teal.css',
        'https://fonts.googleapis.com/css?family=Roboto',
        // 
      ]);
      function loadCssAsync(href) {
        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;

          link.onload = () => resolve(href);
          link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));

          document.head.appendChild(link);
        });
      }

      async function loadMultipleCss(stylesheets) {
        const results = [];

        for (const href of stylesheets) {
          try {
            const res = await loadCssAsync(href);
            //console.log(`Loaded CSS: ${res}`);
            results.push(res);
          } catch (error) {
            console.error(error);
          }
        }

        return results;
      }

    },
    async loadAllJs() {

      return await loadMultipleScripts([
        // 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js',
        // 'https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js'
      ]);

      function loadScriptAsync(src) {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      async function loadMultipleScripts(scripts) {
        for (const src of scripts) {
          try {
            await loadScriptAsync(src);
            //console.log(`Loaded: ${src}`);
          } catch (e) {
            console.error(`Failed to load: ${src}`);
          }
        }
      }

    },

    w3_open() {
      document.getElementById("mySidebar").style.display = "block";
      document.getElementById("myOverlay").style.display = "block";
    },

    w3_close() {
      document.getElementById("mySidebar").style.display = "none";
      document.getElementById("myOverlay").style.display = "none";
    },

    // Change style of top container on scroll
    //window.onscroll = function () { myFunction() };
    myFunction() {
      if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        document.getElementById("myTop").classList.add("w3-card-4", "w3-animate-opacity");
        document.getElementById("myIntro").classList.add("w3-show-inline-block");
      } else {
        document.getElementById("myIntro").classList.remove("w3-show-inline-block");
        document.getElementById("myTop").classList.remove("w3-card-4", "w3-animate-opacity");
      }
    },

    // Accordions
    myAccordion(id) {
      var x = document.getElementById(id);
      if (x.className.indexOf("w3-show") == -1) {
        x.className += " w3-show";
        x.previousElementSibling.className += " w3-theme";
      } else {
        x.className = x.className.replace("w3-show", "");
        x.previousElementSibling.className =
          x.previousElementSibling.className.replace(" w3-theme", "");
      }
    }


  },


}
</script>
<style>

body {
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif
}
.w3-bar-block .w3-bar-item {
  padding: 16px;
  /*font-weight: bold;*/
}


.router-link-active {
  color: blue;
  font-weight: bold;
  background-color: yellow; /* Thêm dòng này */
}

.router-link-exact-active {
  color: red;
  background-color: yellow; /* Thêm dòng này */
}




</style>

